module.exports = __webpack_public_path__ + "static/img/fuwuleirong_24.5b6da7ac.jpg";